"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const projectsList = [
  {
    title: "Large Language Model from Scratch",
    description: "Built a Transformer-based Large Language Model from scratch using PyTorch.",
    tech: ["PyTorch", "Self-Attention"],
    link: "/project/llm",
    image: "/project-img/llm.png",
    category: "ML"
  },
  // {
  //   title: "Face Recognition",
  //   description: "Real-time face tracking and AR filters using MediaPipe and OpenCV.",
  //   tech: ["Computer Vision", "AR"],
  //   link: "/project/rt-face-recogination",
  //   image: "/llm-tokens-light.png",
  //   category: "ML"
  // },
  {
    title: "Image Generation Model from Scratch",
    description: "Built a Stable Diffuser Model from scratch using PyTorch.",
    tech: ["Diffuser", "Pytorch",],
    link: "/project/image-generator",
    image: "/project-img/diffuser.png",
    category: "ML"
  },
  {
    title: "Stock Predictor",
    description: "Deep learning framework for market trends and trading optimization.",
    tech: ["LSTM", "Financial ML"],
    link: "/project/stock-trade",
    image: "/project-img/stockprice2.png",
    category: "ML"
  },
  {
    title: "Youtube Sentiment Analysis",
    description: "Analyzed YouTube comments to gauge public sentiment on various topics using LSTM networks.",
    tech: ["LSTM", "Financial ML"],
    link: "/project/yt-sentiment-analysis",
    image: "/project-img/sentiment-analysis.png",
    category: "ML"
  },
  {
    title: "Language Detection",
    description: "Built a language detection model using NLP techniques.",
    tech: ["NLP", "Machine Learning"],
    link: "/project/language-detection",
    image: "/project-img/language-detection.png",
    category: "ML"
  },
  {
    title: "I Like File",
    description: "ILikeFile.com is your all-in-one online file converter and PDF toolkit. ",
    tech: ["Next.js", "Express.js", "Mongodb"],
    link: "/project/ilikefile",
    image: "/project-img/ilikefile/img2.png",
    category: "Web"
  },
  {
    title: "Notes App",
    description: "Fynote simplifies managing, organizing, and accessing study Notes.",
    tech: ["Next.js", "Express.js", "Mongodb"],
    link: "/project/notes",
    image: "/project-img/notes/img2.png",
    category: "Web"
  },
  {
    title: "Type Champ",
    description: "Type Champ is a typing practice website where users can practice, compete with others.",
    tech: ["React.js", "Express.js", "Mongodb"],
    link: "/project/typechamp",
    image: "/project-img/typechamp/img1.png",
    category: "Web"
  },
];

export default function Projects() {
  const [activeTab, setActiveTab] = useState("All");

  const filteredProjects = activeTab === "All"
    ? projectsList
    : projectsList.filter(p => p.category === activeTab);

  return (
    <section id="projects" className="py-12 px-6 md:px-12 max-w-7xl mx-auto space-y-10 border-b border-slate-50">
      <div className="space-y-6">
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-slate-900">Featured Projects</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[var(--accent-cyan)] to-[var(--accent-purple)] rounded-full"></div>
        </div>

        <div className="flex flex-wrap gap-3 md:gap-4 pt-4">
          {["All", "ML", "Web"].map((type) => (
            <button
              key={type}
              onClick={() => setActiveTab(type)}
              className={`px-3 md:px-8 py-2 cursor-pointer md:py-2.5 rounded-full text-xs md:text-sm font-bold transition-all duration-300 border ${activeTab === type
                ? "bg-slate-900 text-white border-slate-900 shadow-xl"
                : "bg-white border-slate-100 hover:border-slate-300 text-slate-600"
                }`}
            >
              {type === "ML" ? "ML Engineering" : type === "Web" ? "Web Engineering" : "All Projects"}
            </button>
          ))}
        </div>
      </div>

      <div className="">
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 min-h-[400px]"> */}
        {filteredProjects.map((project) => (
          <Link href={project.link} key={project.title} className="group h-full animate-fade-in ">
            <div className="futuristic-card h-full flex items-start p-0 overflow-hidden transition-all duration-500 mt-2 mb-2 ">
              <div className="relative w-25 h-25 ">
                <Image
                  src={project.image}
                  alt={project.title}
                  fill
                  className="object-cover transform group-hover:scale-110 transition w-100 h-100 duration-700 opacity-90 group-hover:opacity-100"
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-white/10 to-transparent"></div> */}
              </div>

              <div className="p-4 space-y-1 flex flex-col flex-grow">
                <div className="flex justify-between items-start">
                  <h3 className="text-sm md:text-lg font-bold text-slate-900 transition-colors leading-tight">
                    {project.title}
                  </h3>
                  <span className="text-[10px] font-black text-slate-500 uppercase tracking-tighter">
                    {project.category}
                  </span>
                </div>
                <p className="text-slate-600 text-[10px] md:text-[13px] leading-relaxed flex-grow">
                  {project.description}
                </p>
                <div className="flex justify-between">
                  <div className="flex flex-wrap gap-1.5 pt-2 border-t border-slate-100">
                    {project.tech.map((tag, tIndex) => (
                      <span key={tIndex} className=" text-[6px] md:text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded bg-slate-50 text-slate-600 border border-slate-100">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="pt-2 flex items-center font-bold text-[10px] md:text-xs gap-1.5 group/btn">
                    Read More
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 transform group-hover/btn:translate-x-1 transition" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
